// Promotion drawers (snippets/sivana-promo-drawers.liquid): tapping a yellow promotion tag
// (snippets/sivana-promo-tag.liquid, `data-sivana-promo-open`) opens that promotion's drawer. Tags can sit
// inside product card links, so the click is caught early and the link doesn't open.
const open = (event) => {
  const tag = event.target.closest('[data-sivana-promo-open]');
  if (!tag) return false;
  const drawer = document.getElementById(`SivanaPromo-${tag.dataset.sivanaPromoOpen}`);
  if (!drawer) return false;
  event.preventDefault();
  event.stopPropagation();
  if (!drawer.open) drawer.showModal();
  return true;
};

if (!window.sivanaPromoReady) {
  window.sivanaPromoReady = true;
  document.addEventListener('click', open, true);
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Enter' || event.key === ' ') open(event);
    },
    true
  );
  document.addEventListener('click', (event) => {
    const drawer = event.target.closest('[data-sivana-promo-drawer]');
    if (!drawer) return;
    if (event.target === drawer || event.target.closest('[data-sivana-promo-close]')) drawer.close();
  });
}
